<template>
  <div class="d-flex align-center">
    <v-btn-toggle
      :value="value"
      dense
      class="list-toggle"
      @change="$emit('input', $event)"
    >
      <v-btn
        small
        value="list"
      >
        <img
          height="20"
          src="/icons/projects-cards.svg"
        >
      </v-btn>

      <v-btn
        small
        value="table"
      >
        <img
          height="20"
          src="/icons/projects-table.svg"
        >
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: 'list',
    },
  },
};
</script>

<style lang="scss" scoped>
.list-toggle {
  border-radius: 0px;

  .v-btn {
    min-width:35px;
    height:35px;
    background-color: white !important;
  }
  .v-btn:not(.v-item--active) {
    opacity: 0.6
  }
}
</style>
